import { IoChevronForward, IoClose } from "react-icons/io5";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { customerAtom } from "../auth";
import { Post } from "./Post";

// セルフ対応（ロッカー/店頭）を一度も使ったことがない顧客に出すガイド導線バナー。
// 10/1料金改定（3km超は配達対象外・セルフは無料継続）に向けた事前の周知が目的。
// - customer.self_used: 1=セルフの預けor受取を利用済み（API側 2026-09-01 追加）
// - 拠点がセルフ対応（lpspot.can_user_dropoff_locker=1）のときだけ表示
//   （ホームは lpspot を持たないため、このコンポーネント内で /lpspot/index.php を取得）
// - 「×」で以後非表示（localStorage保存・端末ごと）
const HIDE_KEY = 'self_guide_banner_hidden';
// 拠点のセルフ対応判定の記憶（CLS対策 2026-09-03）: 判定はAPI応答待ちのため、初回描画時に
// 前回の判定結果で先に描画し、バナーの遅れ挿入で下のメニューが押し下げられるのを防ぐ。
const SPOT_KEY = 'self_guide_spot_ok';

export const SelfGuideBanner = ({ style = {} }) => {
  const [customer] = useAtom(customerAtom);
  const [selfSpotOk, setSelfSpotOk] = useState(() => {
    try { return localStorage.getItem(SPOT_KEY) === '1'; } catch (e) { return false; }
  });
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(HIDE_KEY) === '1'; } catch (e) { return false; }
  });
  // self_used はレガシー(文字列)/D1(数値)の両方に耐えるよう Number で判定
  const notUsed = !!customer?.id && Number(customer.self_used) !== 1;

  useEffect(() => {
    if (!notUsed || hidden) return;
    let unmounted = false;
    (async () => {
      const r = await Post('post', '/lpspot/index.php', {});
      if (unmounted || r?.result !== 1) return;
      const ok = Number(r.lpspot?.can_user_dropoff_locker) === 1;
      setSelfSpotOk(ok);
      try { localStorage.setItem(SPOT_KEY, ok ? '1' : '0'); } catch (e2) { /* no-op */ }
    })();
    return () => { unmounted = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notUsed, hidden]);

  const hide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { localStorage.setItem(HIDE_KEY, '1'); } catch (e2) { /* no-op */ }
    setHidden(true);
  };

  if (hidden || !notUsed || !selfSpotOk) return null;
  return (
    <Link to="/self_guide" className="d-block" style={{ textDecoration: 'none', ...style }}>
      <div style={{ background: '#fef9cc', border: '1px solid #f0dd6b', borderRadius: 10, padding: '12px 14px', color: '#5a4a00', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ fontSize: 14, textAlign: 'left' }}>
          🧺 ロッカー・店頭の<b>セルフ対応なら配達料0円</b>。→ はじめてのセルフ利用ガイド
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 'none' }}>
          <IoChevronForward />
          <IoClose onClick={hide} style={{ color: '#8a6d00', fontSize: 18 }} aria-label="この案内を閉じる" />
        </span>
      </div>
    </Link>
  );
};
